import React, { useEffect, useState } from 'react';
interface PaymentTimerProps {
  duration: number; // in seconds
  onComplete: () => void;
}
export function PaymentTimer({
  duration,
  onComplete
}: PaymentTimerProps) {
  const [timeLeft, setTimeLeft] = useState(duration);
  useEffect(() => {
    if (timeLeft <= 0) {
      onComplete();
      return;
    }
    const timer = setTimeout(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
    return () => clearTimeout(timer);
  }, [timeLeft, onComplete]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const progress = timeLeft / duration * 100;
  return <div data-id="element-124">
      <div className="flex items-center justify-between mb-2" data-id="element-125">
        <span className="font-medium" data-id="element-126">Time remaining to complete payment</span>
        <span className="font-bold" data-id="element-127">
          {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-128">
        <div className="bg-green-600 h-2.5 rounded-full transition-all duration-1000" style={{
        width: `${progress}%`
      }} data-id="element-129"></div>
      </div>
    </div>;
}